import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import type { TrackingEvent } from 'webapp/enums/tracking';

import Serviced from 'webapp/models-custom/serviced';

export interface TourReactStep {
	/** Copy key in the React ai.json Tour namespace. */
	id: string;
	/** Anchor id the owning component passes to `useTourAnchor`. */
	anchorId: string;
	side?: 'top' | 'bottom' | 'left' | 'right';
	align?: 'start' | 'center' | 'end';
}

export interface TourReactPayload {
	id: string;
	steps: TourReactStep[];
}

/**
 * Base for tours whose bubble is rendered by React.
 *
 * Unlike Tour, this never touches popupService: React owns rendering, anchoring and step
 * navigation. Ember keeps ownership of gating, "seen" persistence and analytics.
 */
export default abstract class TourReact extends Serviced {
	@service('analytics') declare analyticsService: Service.Analytics;

	trackEvent: TrackingEvent | '' = '';

	abstract get id(): string;

	abstract get steps(): TourReactStep[];

	get keyForPersistantDone(): string {
		return '';
	}

	toPayload(): TourReactPayload {
		return { id: this.id, steps: this.steps };
	}

	start(): void {
		if (this.trackEvent) {
			this.analyticsService.event(this.trackEvent);
		}
	}

	markDone(): void {
		const key = this.keyForPersistantDone;

		if (key) {
			this.markPersistant('done', key);
		}
	}

	reset(): void {
		const key = this.keyForPersistantDone;

		if (key) {
			this.markPersistant('reset', key);
		}
	}

	markPersistant(_status: string, _key: string): void {
		// defined in tour service.
	}
}
